import React, { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import { FrequencyEnum, globalSelectStyles } from "../../../middleware/enum";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import Utils from "../../../middleware/Utils";
import SuccessModal from "../../../components/common/SuccessModal";
import { format } from "date-fns";

import {
  AddUpdateService,
  GetServiceModel,
} from "../../../services/Service/ServiceApi";
import { GetCustomerIndustryLookupList } from "../../../services/CustomerIndustry/CustomerIndustryApi";

const AddUpdateServiceModal = ({
  isOpen,
  onClose,
  setIsAddUpdateDone,
  modelRequestData,
}) => {
  // Single state for all form fields

  const inputRef = useRef(null);
  const ModuleName = "Predefined";
  const [industryName, setClientIndustryName] = useState("");
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const { authDetails } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [serviceObj, setServiceObj] = useState({
    serviceName: "",
    servicePrice: "",
    frequencyID: null,
    customFrequencyDate: "",
    customerIndustryID: null,
  });
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [customerIndustryID, setCustomerIndustryID] = useState("");
  const [customerIndustryOptions, setcustomerIndustryOptions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
      GetCustomerIndustryLookupListData();
    }
  }, [isOpen]);

  const GetCustomerIndustryLookupListData = async () => {
    try {
      const adminKeyID = authDetails?.adminKeyID;
      if (!adminKeyID) return;

      let response = await GetCustomerIndustryLookupList(adminKeyID);

      console.log("API Response:", response); // Debugging step

      // Check if response contains data
      if (response?.statusCode === 200) {
        const customerIndustryOption = response?.responseData?.data.map(
          (val) => ({
            value: val.customerIndustryID,
            label: val.customerIndustryName,
          })
        );
        console.log("Mapped Options:", customerIndustryOption); // Confirm correct mapping

        setcustomerIndustryOptions(customerIndustryOption);
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching market lookup list:", error);
    }
  };

  //getModel
  useEffect(() => {
    if (modelRequestData) {
      setModelAction(modelRequestData.Action === null ? "Add" : "Update");
      if (
        modelRequestData.KeyID !== undefined &&
        modelRequestData.KeyID !== null &&
        modelRequestData.Action === "Update"
      ) {
        GetServiceModelData(modelRequestData.KeyID);
      } else {
        setClientIndustryName("");
      }
      setErrorMessage("");
    }
  }, [modelRequestData]);

  //Get Model

  const GetServiceModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetServiceModel(
      ModuleName,
      KeyID,
      authDetails.adminKeyID
    );
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      const formattedDate = format(
        new Date(ModalData.customFrequencyDate),
        "yyyy-MM-dd"
      );

      setServiceObj({
        serviceName: ModalData.serviceName,
        servicePrice: ModalData.servicePrice,
        frequencyID: ModalData.frequencyID,
        customFrequencyDate: formattedDate, // Use the formatted date
        customerIndustryID: ModalData.customerIndustryID,
      });
    } else {
      setLoader(false);
    }
  };
  // Generic handler for input fields
  const handleChange = (field, value) => {
    setServiceObj((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Submit handler (optional for demonstration)
  const handleSubmit = async () => {
    if (
      serviceObj.serviceName === undefined ||
      serviceObj.serviceName === null ||
      serviceObj.serviceName === "" ||
      serviceObj.servicePrice === undefined ||
      serviceObj.servicePrice === null ||
      serviceObj.servicePrice === "" ||
      serviceObj.frequencyID === undefined ||
      serviceObj.frequencyID === null ||
      serviceObj.frequencyID === "" ||
      serviceObj.customerIndustryID === undefined ||
      serviceObj.customerIndustryID === null ||
      serviceObj.customerIndustryID === "" ||
      (serviceObj.frequencyID == FrequencyEnum.Custom &&
        (serviceObj.customFrequencyDate === undefined ||
          serviceObj.customFrequencyDate === "" ||
          serviceObj.customFrequencyDate === null))
    ) {
      setRequireErrorMessage(true);
      return false;
    }
    setLoader(true);
    try {
      const data = await AddUpdateService({
        adminKeyID: authDetails.adminKeyID,
        serviceKeyID: modelRequestData.KeyID,
        serviceName: serviceObj.serviceName,
        servicePrice: serviceObj.servicePrice,
        frequencyID: serviceObj.frequencyID,
        customerIndustryID: serviceObj.customerIndustryID,
        customFrequencyDate:
          serviceObj.frequencyID == FrequencyEnum.Custom
            ? serviceObj.customFrequencyDate
            : null,
        clientIndustryKeyID: modelRequestData.KeyID,
        ModuleName: ModuleName,
      });
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
        setShowSuccessPopupModal(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  if (!isOpen) return null;
  const validateInput = (e) => {
    let value = e.target.value;

    if (value) {
      let floatValue = parseFloat(value);

      if (isNaN(floatValue)) {
        floatValue = "";
      } else {
        const [integerPart] = value.split(".");
        if (integerPart.length > 5) {
          floatValue = 99999.0;
        }

        floatValue = floatValue.toFixed(2);
      }

      setServiceObj((prev) => ({
        ...prev,
        servicePrice: floatValue,
      }));
    }
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
      {/* Background Overlay */}
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal Box */}
      <div className="bg-white rounded-lg shadow-lg z-10 w-full max-w-[90%] sm:w-1/3">
        {/* Header */}
        <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
          <h2 className="text-16 font-semibold">{modelAction} Service</h2>{" "}
          <button
            className="text-gray-500 hover:text-gray-700 text-xl"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6 text-12">
          <div className="mb-4">
            <label className="block text-12 text-gray-700 mb-1">
              Customer Industry <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              options={customerIndustryOptions}
              value={customerIndustryOptions.find(
                (option) => option.value === serviceObj.customerIndustryID // Use serviceObj.customerIndustryID
              )}
              onChange={(selectedOption) => {
                const selectedValue = selectedOption
                  ? selectedOption.value
                  : "";
                setCustomerIndustryID(selectedValue);
                handleChange("customerIndustryID", selectedValue); // Update serviceObj as well
              }}
              menuLimenuPlacement="top"
              styles={globalSelectStyles}
            />
            {requireErrorMessage &&
            (serviceObj.customerIndustryID === "" ||
              serviceObj.customerIndustryID === undefined ||
              serviceObj.customerIndustryID === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>

          {/* Service Name Input */}
          <div className="mb-4">
            <label className="block  text-gray-700 mb-1">
              Service Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              value={serviceObj.serviceName}
              maxLength={150}
              onChange={(e) => handleChange("serviceName", e.target.value)}
              className="w-full p-2 border rounded-md text-12 "
              placeholder="Enter Service Name"
            />
            {requireErrorMessage &&
            (serviceObj.serviceName === "" ||
              serviceObj.serviceName === undefined ||
              serviceObj.serviceName === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>

          {/* Cost Per Service Input */}
          {/* Cost Per Service Input */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">
              Cost Per Service (₹) <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              value={serviceObj.servicePrice}
              onChange={(e) => {
                const value = e.target.value;
                const regex = /^\d{0,5}(\.\d{0,2})?$/; // Corrected regex

                // Allow empty input or valid numeric input
                if (value === "" || regex.test(value)) {
                  setServiceObj((prev) => ({
                    ...prev,
                    servicePrice: value,
                  }));
                }
              }}
              onBlur={(e) => validateInput(e)}
              className="w-full p-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter Cost"
              step="0.01"
              min="0"
              max="99999.99"
            />
            {requireErrorMessage &&
            (serviceObj.servicePrice === "" ||
              serviceObj.servicePrice === undefined ||
              serviceObj.servicePrice === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>

          {/* Frequency Select */}
          <div className="mb-4">
            <label className="block text-12 text-gray-700 mb-1">
              Frequency <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              options={Utils.frequencyOptions}
              value={Utils.frequencyOptions.find(
                (item) => item.value == serviceObj.frequencyID
              )}
              onChange={(selectedOption) =>
                handleChange("frequencyID", selectedOption.value)
              }
              menuLimenuPlacement="top"
              styles={globalSelectStyles}
            />
            {requireErrorMessage &&
            (serviceObj.frequencyID === "" ||
              serviceObj.frequencyID === undefined ||
              serviceObj.frequencyID === null) ? (
              <label className="validation">{ERROR_MESSAGES}</label>
            ) : (
              ""
            )}
          </div>

          {/* Custom Date Input (Only visible when "Custom" is selected) */}
          {serviceObj.frequencyID == FrequencyEnum.Custom && (
            <div className="mb-4">
              <label className="block  text-gray-700 mb-1">
                Select Date <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="date"
                value={serviceObj.customFrequencyDate}
                onChange={(e) =>
                  handleChange("customFrequencyDate", e.target.value)
                }
                className="w-full p-2 border rounded-md text-12 "
              />
              {requireErrorMessage &&
              ((serviceObj.frequencyID == FrequencyEnum.Custom &&
                serviceObj.customFrequencyDate === "") ||
                serviceObj.customFrequencyDate === undefined ||
                serviceObj.customFrequencyDate === null) ? (
                <label className="validation">{ERROR_MESSAGES}</label>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
        {errorMessage && (
          <div className="text-center mb-2">
            <label className="validation ">{errorMessage}</label>
          </div>
        )}
        {/* Footer */}
        <div className=" px-6 py-4 border-t flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 bg-gray-300 rounded-md text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => handleSubmit()}
            className="px-4 py-2 text-white bg-[#E86B1B] rounded-md text-sm"
          >
            Submit
          </button>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => {
          onClose();
          setShowSuccessPopupModal(false);
        }}
        modelAction={modelAction}
        actionMessage={serviceObj.serviceName}
      />
    </div>
  );
};

export default AddUpdateServiceModal;
